import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

export const accordionIndicatorIcon: IIcon = new Icon(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 48"><path d="M0 0h64L32 48z"/></svg>`);
